import React from 'react';
import Vegetarian from '../asset/Home/purpose/Vegetarian.png';
import Losing_weight from '../asset/Home/purpose/Losing_weight.png';
import Fitness from '../asset/Home/purpose/Fitness.png';

function Purpose() {
  return (
    <div className="lg:px-[150px] px-[25px] py-[10px] ">
      <p className="text-dark-2 lg:text-h1 text-h2 font-semibold py-[25px]">
        Purpose
      </p>
      <div className="flex justify-between lg:flex-row flex-col gap-4 text-center">
        {/* Item 1 */}
        <div className="relative  opacity-70 hover:opacity-80  overflow-hidden shadow-lg cursor-pointer rounded-[20px]">
          <div className="bg-black/60 absolute z-30 w-full h-full" />
          <img
            className="object-cover lg:w-[360px] lg:h-[160px] w-[100%]  h-full rounded-[20px]"
            src={Losing_weight}
            alt="Losing weight"
          />

          <div className="absolute top-[25%] left-[25%] px-6 py-4 z-40">
            <h4 className="   text-center text-xl font-semibold tracking-tight text-white/80">
              Losing Weight
            </h4>
          </div>
        </div>
        {/* Item2  */}
        <div className="relative  opacity-70 hover:opacity-80  overflow-hidden shadow-lg cursor-pointer rounded-[20px]">
          <div className="bg-black/60 absolute z-30 w-full h-full" />
          <img
            className="object-cover lg:w-[360px] lg:h-[160px]w-[100%]  h-full rounded-[20px]"
            src={Fitness}
            alt="Fitness"
          />

          <div className="absolute top-[25%] left-[25%] px-6 py-4 z-40">
            <h4 className="   text-center text-xl font-semibold tracking-tight text-white/80">
              Fitness
            </h4>
          </div>
        </div>

        {/* Item 3 */}

        <div className="relative  opacity-70 hover:opacity-80  overflow-hidden shadow-lg cursor-pointer rounded-[20px]">
          <div className="bg-black/60 absolute z-30 w-full h-full" />
          <img
            className="object-cover lg:w-[360px] lg:h-[160px] w-[100%]  h-full rounded-[20px]"
            src={Vegetarian}
            alt="Vegetarian"
          />

          <div className="absolute top-[25%] left-[25%] px-6 py-4 z-40">
            <h4 className="text-center text-xl font-semibold tracking-tight text-white/80">
              Vegeterian
            </h4>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Purpose;
